import "backbone-associations";
import { AppSettings } from "../../app-settings";
import { ApplicationInsights } from "../../shared/helpers/application-insights";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class AuthorizationModel extends Backbone.AssociatedModel {

    public static attachAuthorizationHeader(xhr: JQueryXHR): void {
        const user = ContainerHelper.AuthService.oidcUser;
        if (user) {
            xhr.setRequestHeader("Authorization", `${user.token_type} ${user.access_token}`);
        }
    }

    private dataXHR: JQueryXHR;

    constructor(options?) {
        super(options);
    }

    public save(attributes: any, options?: any): any {
        options = options || {} ;
        this.cancelOutstandingRequests();
        _.extend(options, { beforeSend: this.attachAuthorizationHeader, cache: false });
        this.dataXHR = super.save.call(this, attributes, options);
        return this.dataXHR;
    }

    public fetch(options?: Backbone.ModelFetchOptions): any {
        options = options || {};
        this.cancelOutstandingRequests();
        _.extend(options, { beforeSend: this.attachAuthorizationHeader, cache: false });
        this.dataXHR = super.fetch.call(this, options);
        return this.dataXHR;
    }

    public attachAuthorizationHeader(xhr: JQueryXHR): void {
        AuthorizationModel.attachAuthorizationHeader(xhr);
    }

    private cancelOutstandingRequests() {
        if (this.dataXHR) { this.dataXHR.abort(); }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/models/authorization-model.ts